import React from 'react';
import { expandFontTheme, theme } from '@contrast-security-inc/design-system-foundations';
import { css, cx } from '@emotion/css';
import { ListboxActions } from '.';
import { selectInputWrapperOpenMenuStyles, selectInputWrapperStyles, inputDisabledStyles, inputErrorStyles, inputWrapperStyles, selectedItemTextStyles, selectedItemsWrapperStyles, } from '../shared';
import { setupSafelyCallItemToID } from './utils';
import { DropdownSelectedItem } from './DropdownSelectedItem';
/** we have to have special label classes because we do not want to move the label up before selection */
const dropdownInputStyles = css `
  outline: none;

  input {
    cursor: pointer;
    width: 100%;
  }

  input + label {
    transition-duration: 0ms;
    white-space: nowrap;
  }

  input[value=""] + label {
    ${expandFontTheme(theme.font.body)}
    color: ${theme.color.neutral70};
    display: flex;
    height: 24px;
    left: 10px;
    pointer-events: none;
    position: absolute;
    top: calc(50% - 12px);
    right: 38px; /* save room for button */
  }

  input[value=""] ~ fieldset > legend {
    padding: 0;
    max-width: 0px;
  }
`;
export const DropdownInput = ({ ariaLabel, className, inputWrapperSpanClassName, dropdownWrapperRef, describers, error, getLabelProps = (_p) => ({}), getToggleButtonProps = (_p) => ({}), inputHeight, isDisabled, isOpen, isRequired, itemToID, itemToString, label, onClick, onBlur, showOverflowTooltip = true, placeholder = '', renderInputValue, selectedItem, testId, uniqueId = '', }) => {
    const inputProps = {
        'aria-describedby': describers,
        'aria-errormessage': `${uniqueId}-error`,
        'aria-invalid': !!error,
        'aria-label': ariaLabel,
        disabled: isDisabled,
        id: uniqueId,
        placeholder,
        required: isRequired,
        type: 'text',
    };
    const labelProps = getLabelProps({ htmlFor: uniqueId });
    const isLabelHidden = !label || !!placeholder;
    const toggleButtonProps = getToggleButtonProps();
    return (React.createElement("div", { "data-testid": `${testId}-input-wrapper`, ref: dropdownWrapperRef, className: cx(inputWrapperStyles(label && !placeholder), selectInputWrapperStyles(false), dropdownInputStyles, isDisabled && inputDisabledStyles, error && inputErrorStyles, selectInputWrapperOpenMenuStyles(isOpen), className) },
        React.createElement("span", { className: cx(selectedItemsWrapperStyles(false, inputHeight, false, isDisabled), inputWrapperSpanClassName), onClick: onClick, 
            // @ts-ignore
            onKeyDown: onClick, onBlur: (event) => {
                if (onBlur) {
                    onBlur(event);
                }
            }, "data-testid": `${testId}-input-wrapper-span` },
            React.createElement("span", { "data-testid": `${testId}-dropdown-button-overlay`, className: css `
            align-items: center;
            width: 100%;
          ` },
                !selectedItem && placeholder && (React.createElement("span", { className: cx('ds-dropdown-input-value', selectedItemTextStyles(false), css `
            color: ${theme.color.neutral70};
            ${expandFontTheme(theme.font.bodyItalic)}
          `), "data-testid": `${testId}-selected-item-input-value` }, placeholder)),
                selectedItem && (React.createElement(DropdownSelectedItem, { isOpen: isOpen, selectedItem: selectedItem, itemToString: itemToString, renderInputValue: renderInputValue, testId: testId, showOverflowTooltip: showOverflowTooltip, onClick: toggleButtonProps.onClick })),
                React.createElement("input", { ...inputProps, ...toggleButtonProps, className: css `
            text-overflow: ellipsis;
            opacity: 0;
          `, placeholder: placeholder, onChange: () => {
                        // suppresses the react error because our input value is always changed from the menu
                        return undefined;
                    }, "data-testid": `${testId}-input`, value: setupSafelyCallItemToID(itemToID, itemToString, selectedItem) || '' }),
                React.createElement("label", { ...labelProps, hidden: isLabelHidden, className: cx(labelProps.className, css `
                &&& {
                  display: ${isLabelHidden ? 'none' : undefined};
                }
              `), "data-testid": `${testId}-label` }, label || ariaLabel),
                React.createElement("fieldset", null, label && !placeholder && React.createElement("legend", null, label)))),
        React.createElement(ListboxActions, { isDisabled: isDisabled, isOpen: isOpen, testId: `${testId}-actions`, 
            // the full toggle button props will switch this button to a combobox, we only want to trigger the menu
            getToggleButtonProps: () => ({ onClick: toggleButtonProps.onClick }) })));
};
